import { Notification } from "types/generated";

/**
 * Check if the current user can dismiss the notification
 */
export const canDismissNotification = (notification: Notification): boolean => {
  return !notification.dismissed;
};
